import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import CustomToggleButton from '../../shared-components/custom-toggle-button/CustomToggleButton';
import PageTitle from '../../shared-components/page-title/PageTitle';

import MaintenanceManagement from './components/MaintenanceManagement';
import MaintenanceSchedule from './components/MaintenanceScheduling';

/**
 *  function component
 */
function Management() {
  const navigate = useNavigate();
  const { page } = useParams<{ page: string }>();

  /**
   *  handleTabChange
   */
  const handleTabChange = (tabNumber: number) => {
    navigate(tabNumber === 1 ? '../maintenance' : '../schedule');
  };

  return (
    <div className="maintenance-schedule-warp">
      <div>
        <PageTitle title="Maintenance Scheduling & Management" />
      </div>
      {/* Tabs */}
      <div className="tabs">
        <CustomToggleButton
          labels={['Maintenance Schedule', 'Maintenance Management']}
          defaultActiveIndex={page === 'schedule' ? 0 : 1}
          onToggle={handleTabChange}
        />
      </div>

      <div className="content">
        {page === 'schedule' ? <MaintenanceSchedule /> : <MaintenanceManagement />}
      </div>
    </div>
  );
}

export default Management;
